import { Mail, Phone } from "lucide-react";
import "../styles/assistanceCardStyles.css";

function AssistanceCard() {
  return (
    <div className="assistCard">
      <h2>Need Immediate Assistance?</h2>
      <p>Our support team us available to help restore your website.</p>

      <div className="assistCard_contacts">
        <div className="assistCard_contact">
          <Phone className="assistCard__icon bg-green" />
          <h3>Phone Support</h3>
          <a href="tel:586=784-5976">1-586-784-5976</a>
        </div>
        <div className="assistCard_contact">
          <Mail  className="assistCard__icon bg-blue"/>
          <h3>Email Support</h3>
          <a href="mailto:matt@mataodesigns.com">matt@mataodesigns.com</a>
        </div>
      </div>
    </div>
  )
}

export default AssistanceCard;